export default {
  navigateTo(url) {
    window.location.href = url;
  },

  reload() {
    window.location.reload();
  }
};
